import Dw from './dw';

import modules from './modules';

const APP_KEY = 'ee7bbddd245b7283';

const collect = new Dw(APP_KEY);

// 批量挂载各模块的打点函数
Object.keys(modules).forEach((key) => {
  collect[key] = modules[key];
});

// 输出为插件，$collect可以访问
export default (info, inject) => {
  inject('collect', collect);
};
